<template>
  <div class="mt-10 pt-10 sm:pt-14 sm:mt-20 border-t-2 border-primary-light dark:border-secondary-dark">
    <p class="font-general-regular text-primary-dark dark:text-primary-light text-3xl font-bold mb-10 sm:mb-14 text-left">
      <!-- {{ relatedProject.relatedProjectsHeading }} -->
      {{ $t('relatedProjectsHeading') }}
    </p>

    <div class="grid grid-cols-1 sm:grid-cols-4 gap-10">
      <div v-for="item in relatedProject.relatedProjects" :key="item.id">
        <!-- go to single project page by click image below -->
        <router-link :to="{ name: 'SingleProject', params: { id: item.id } }"
          class="rounded-xl shadow-lg hover:shadow-xl cursor-pointer mb-10 sm:mb-0 bg-secondary-light dark:bg-ternary-dark flex justify-center"
          aria-label="Single Project" :project="projects[item.id]">
          <img :src="item.img" class="rounded-xl cursor-pointer" :alt="item.title" />
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import projects from '../../data/projects.js';
export default {
  props: ['relatedProject'],
  data() {
    return {
      projects,
    }
  },
};
</script>

<style scoped>
img {
  height: 150px;
  width: 100%;
  max-height: 200px;
}
</style>